import { ConsignmentCreateProformaPage } from "@/features/consignment-settlement/pages/ConsignmentCreateProformaPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/consignment-settlement/create")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({ permissions: ["vendor_consignment.edit"] })
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ConsignmentCreateProformaPage,
});
